<template>
    <!-- Telechargement -->
        <section id="telechargement" class="view-container  Telechargement  ">
            <div class="view-content">
                <article class="Presentation-image">
                    <div class="card-container">
                        <div class="card">
                            <img src="images/opaleboitier.jpg" class="presentation-card" alt="presentation">
                        </div>
                    </div>
                </article>
                <article class="Presentation-texte">
                    <h2 class="titre-pokeball">
                        <img src="images/pokeball.svg" alt="pokéball">Téléchargement
                    </h2>
                    <p class="texte-cta">
                        Le jeu <span class="bold">POKéMON Opale</span> n'est pas encore disponible en téléchargement.<br>
                        Le projet est toujours <span class="bold">en cours de développement</span>, mais la sortie approche&nbsp;!<br>
                        Restez à l'écoute pour les mises à jour, et revenez ici pour obtenir le lien de téléchargement une fois le jeu finalisé.

                    </p>
                    <div class="cta-container  hide">
                        <a href="#telechargement" class="cta">
                            Télecharger
                        </a>
                    </div>
                    <br>
                    <br>
                    <h2 class="titre-pokeball">
                        <img src="images/pokeball.svg" alt="pokéball">Notes de patchs d'avancement
                    </h2>

                    
                        <div class="patch-subentry">
                            <p class="bold">Patch du 1 décembre 2025 - v.0.900</p>
                            <p class="texte-cta">
                                - Scale gain expérience.<br>
                                - Evolitions implantées.<br>
                                - Niveaux max sauvages corrigé.<br>
                                - Evolution des POKéMON des dresseurs.<br>
                                - POKéBALL drop corrigé.<br>
                                - Gravement empoisonné = icone KO, corrigé.<br>
                                - Sprite coloré automatiquement.<br>
                                - Sprite shiney automatiques.<br>
                                - Page badge = noir, corrigé.<br>
                                - POKéMON sauvages sur map aléatoires, corrigé.<br>
                                - Tous les dialogues corrigés.<br>
                                - Chaussures de sports corrigées.<br>
                                - Chutes dans trous au bon endroit.<br>
                                - Miel amélioré.<br>
                                - Corrections multiples du jeu de cartes.<br>
                                - Rentrer dans un centre soigne automatiquement, corrigé.<br>
                                - Affichage des objets possédés à l’achat.<br>
                                - Arène d’écorcia corrigée.<br>
                                - Menu / Corde sortie corrigé.<br>
                                - Soins même si juste PP manquants.<br>
                                - Régions OK.<br>
                                - Absorbe eau, corrigé.<br>
                                - Prof OLIVILLE, corrigé.<br>
                                - Jadielle maison, corrigée.<br>
                                - Accès à toutes les régions depuis le POKéDEX ou la MAP.<br>
                                - Révision des faiblesses des types décalés.<br>
                                - Textes des talents corrigés.<br>
                                - Textes des attaques corrigé.<br>
                                - Quand POKéMON KO, possibilité de faire “RETOUR” corrigé.<br>
                                - BOUTIQUE qui téléporte au centre POKéMON, corrigé.<br>
                                - CEINTURE et PC, corrigé.<br>
                                - Arène de Jadielle = crash, corrigé.<br>
                                - Corrections des panneaux sans textes.<br>
                                - Forêt d’ECORCIA, corrigée.<br>
                                - Possibilité d’annuler un prêt au joueur 2.<br>
                                - Impossibilité de prêter un POKéMON trop haut niveau.<br>
                                - Passage CELADON, corrigé.<br>
                                - Nom des attaques trop longues pour PP plus, corrigé.<br>
                                - Mur invisible ROUTE 36, corrigé.<br>
                                - TELEPORT et CORDE SORTIE, corrigés.<br>
                                - OBJET enregistré = F5, corrigé.<br>
                                - Possibilité d’afficher visuellement les dresseur aux POKéMON trop hauts niveaux.<br>
                                - Affichage de la quête du scénario en cours.<br>
                                - Prix de revente des cartes, corrigé.<br>
                                - Nom du joueur 2 non enregistré, corrigé.<br>
                                - Pêcher ne lance pas le combat, corrigé.<br>
                                - Ne pas pouvoir donner un POKéMON prété.<br>
                                - Changement de joueur = mise à jour région, corrigé.<br>
                                - TUNNEL et VOl, POKéMON toujours visible, corrigé.<br>
                                - VIVE GRIFFE = erreur, corrigé.<br>
                                - PHOTOCOPIE rate toujorus, corrigé.<br>
                                - Les baies ne reviennent pas le lendemain, corrigé.<br>
                                - Jeu de rythme, lots adaptés.<br>
                                - Resprite des 3 premières générations.<br>
                                - Bateau, scène tronquée, corrigé.<br>
                                - KIMONO de ROSALIA refuse le combat, corrigé.<br>
                                - Relisting des map, pokémon et objets présents.<br>
                                - Vérification de toutes les métadata de l’ensemble des maps.<br>
                                - Modifications du compiler pour la lecture des scripts et des maps.<br>
                            </p>
                        </div>



                        <input type="checkbox" class="toggle-patch" id="toggle-patch">
                        <label for="toggle-patch" class="patch-label cta">Voir les anciens patchs</label>
                        <div class="autres-patchs">
                        <div class="patch-subentry">
                            <p class="bold">Patch du 6 août 2025 - v.0.882</p>
                            <p class="texte-cta">
                                - Correction de la police (Œ, œ, Ô, ô).<br>
                                - Optimisation du chargement des scripts.<br>
                                - Ajustement de la taille de la fenêtre de dialogues.<br>
                                - Ajout de plusieurs quêtes annexes à Kanto.<br>
                                - Adaptation des équipes des champions.<br>
                                - Amélioration du système de scaling des dresseurs.<br>
                            </p>
                        </div>
                        <div class="patch-subentry">
                        <p class="bold">Patch du 28 juillet 2025 - v.0.881</p>
                        <p class="texte-cta">
                            - Correction du bug de la maison qui ne se lançait pas.<br>
                            - Correction de la version Android qui ne se lançait pas.<br>
                            - Correction de plusieurs attaques (liste 49 : Faux-Chage, Explosion, Destruction).<br>
                            - Correction de plusieurs objets.<br>
                            - Traduction de textes manquants.<br>
                        </p>
                        </div>
                        <div class="patch-subentry">
                        <p class="bold">Patch du 27 juillet 2025 - v.0.880</p>
                        <p class="texte-cta">
                            - Ajout d’une version test des combats.<br>
                        </p>
                        </div>
                        <div class="patch-subentry">
                        <p class="bold">Patch du 24 juillet 2025 - v.0.879</p>
                        <p class="texte-cta">
                            - Correction du bug lié au switch d’équipes.<br>
                            - Ajout de plusieurs quêtes annexes à Johto.<br>
                            - Ajout d’éléments visuels personnalisés.<br>
                        </p>
                        </div>
                        <div class="patch-subentry">
                        <p class="bold">Patch du 6 juillet 2025 - v.0.878</p>
                        <p class="texte-cta">
                            - Nettoyage de la base de données.<br>
                            - Suppression de fichiers inutiles.<br>
                            - Correction des échanges.<br>
                        </p>
                        </div>

                        <div class="patch-subentry">
                            <p class="bold">Patch du 1er juillet 2025 - v.0.877</p>
                            <p class="texte-cta">
                                - Correction de 36 attaques (liste 48).<br>
                                - Ajout de plusieurs objets stratégiques.<br>
                                - Amélioration de certains sprites.<br>
                                - Ajout de nouveaux éléments visuels.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 20 juin 2025 - v.0.876</p>
                            <p class="texte-cta">
                                - Ajout d’un mini-jeu de rythme.<br>
                                - Ajout des Ruines Alpha.<br>
                                - Ajout d’arènes personnalisées.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 18 juin 2025 - v.0.875</p>
                            <p class="texte-cta">
                                - Ajout du concours de capture d’insectes.<br>
                                - Ajout de QTE pendant les combats.<br>
                                - Ajout de QTE pendant la capture.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 12 juin 2025 - v.0.874</p>
                            <p class="texte-cta">
                                - Correction de la traduction des natures.<br>
                                - Première version du scaling adaptatif des dresseurs.<br>
                                - Optimisation du fonctionnement de la pension.<br>
                                - Ajout du mode Safari.<br>
                                - Ajout du jeu de cartes.<br>
                                - Ajout d’une IA avec changement de POKéMON si besoin.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 3 juin 2025 - v.0.873</p>
                            <p class="texte-cta">
                                - Ajout des niveaux de difficulté.<br>
                                - Ajout du mode Nuzlocke.<br>
                                - Correction de textes liés aux talents.<br>
                                - Correction de l’écran résumé.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 23 mai 2025 - v.0.872</p>
                            <p class="texte-cta">
                                - Corrections des textes et dialogues.<br>
                                - Gestion des deux équipes de héros.<br>
                                - Correction du bug du "pêcheur".<br>
                                - Correction de la téléportation impossible.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 5 mai 2025 - v.0.871</p>
                            <p class="texte-cta">
                                - Ajout du mode Safari.<br>
                                - Ajout des zones de fonds marins.<br>
                                - Compilation des scripts.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 10 avril 2025 - v.0.870</p>
                            <p class="texte-cta">
                                - Ajout du Cherch’Objet.<br>
                                - Corrections des objets.<br>
                                - Ajout de la liste complète des objets et POKéMON.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 22 mars 2025 - v.0.865</p>
                            <p class="texte-cta">
                                - Réécriture de certaines parties du scénario.<br>
                                - Ajout de la sauvegarde Android.<br>
                                - Compilation personnalisée des images et sons.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 12 janvier 2025 - v.0.800</p>
                            <p class="texte-cta">
                                - Ajout du système d’échanges.<br>
                                - Correction de la police sur Android.<br>
                                - Correction de l’erreur de compilation.<br>
                                - Ajout d’un système de partage de sauvegarde.<br>
                                - Ajout d’un mode de pêche avancé.<br>
                                - Ajout de nouvelles quêtes secondaires.<br>
                                - Mise à jour des emplacements d’objets et de POKéMON.<br>
                                - Optimisation des animations et dialogues scénarisés.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 4 septembre 2024 - v.0.720</p>
                            <p class="texte-cta">
                                - Connexion complète de toutes les régions.<br>
                                - Ajout de nombreuses quêtes secondaires.<br>
                                - Optimisation des animations de combat et de capture.<br>
                                - Amélioration du système de gestion des arènes et équilibrage des types.<br>
                            </p>
                            </div>
                            <div class="patch-subentry">
                            <p class="bold">Patch du 10 juillet 2024 - v.0.710</p>
                            <p class="texte-cta">
                                - Implémentation des niveaux de difficulté personnalisables.<br>
                                - Révision complète des statistiques des dresseurs.<br>
                                - Ajout de nouveaux objets pour remplacer les CS.<br>
                            </p>
                            </div>
                        </div>




                    <div class="cta-container  hide">
                        <a href="#telechargement" class="cta">
                            Télecharger
                        </a>
                    </div>
                </article>

            </div>
        </section>
    <!-- Telechargement -->
</template>

<script>
    export default {
        name: 'Telechargement',
        data() {
            return {
            };
        },
        methods: {
        },
        mounted() {
        },
    };
</script>

<style scoped>

    .view-container{
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #a5cefa33;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border-radius: 50px;
        padding: 40px 40px;
        margin-top: 100px;
        margin-bottom: 50px;
        border: solid 1px #49a7d5;
    }

    .toggle-patch {
        display: none;
    }

    .cta.small {
        font-size: 0.9rem;
        padding: 6px 14px;
        margin-top: 10px;
        }

    .patch-label {
        cursor: pointer;
        display: inline-block;
        margin-bottom: 5px;
        color: #333;
    }

    .patch-details {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
        padding-left: 10px;
    }

    .toggle-patch:checked + .patch-details {
        max-height: 1000px;
        margin-top: 5px;
    }
    .toggle-patch:checked + .patch-label{
        display : none;
    }
    .autres-patchs {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: all 0.3s ease;
    }

    .patch-entry {
        margin-bottom: 15px;
    }

    #toggle-patch:checked ~ .autres-patchs {
        max-height: 5000px;
        opacity: 1;
        margin-top: 10px;
    }

    .presentation{
        width:100%;
        position: relative;
        z-index: 1;
        background-image: linear-gradient(90deg, rgb(0 0 0 / 2%) 2px, #00000000 1px), linear-gradient(rgb(0 0 0 / 2%) 2px, #00000000 1px);
        background-size: 10px 10px;
        animation: scroll-grid 1s linear infinite;

    }
    .presentation-card{
        border-radius: 20px;
        width:100%;
    }
    .card-container {
        perspective: 1000px;
        width: 80%;
        margin: 50px auto;
    }
    .card {
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.6s;
        transform: rotateY(-5deg);
        filter: drop-shadow(12px 12px 6px #00000055);
        transition: 0.3s;
        overflow: hidden;
    }
    .card:hover {
        transform: rotateY(5deg);
        filter: drop-shadow(-12px 12px 6px #00000055);
    }


    .card::before {
        content: '';
    position: absolute;
    top: -100%;
    left: -150%;
    width: 200%;
    height: 300%;
    background: linear-gradient(45deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
    transition: transform 1s ease;
    transform: translateX(-100%) rotate(25deg);
    }

    .card:hover::before {
        transform: translateX(200%) rotate(25deg);
    }


    .card-front {
        z-index: 2;
        transform: rotateY(0deg);
    }
    .card-back {
        transform: rotateY(180deg);
    }
    .Presentation-texte{
        width: 100%;
        background-color: #FFF;
        height: -moz-fit-content;
        height: fit-content;
        padding: 30px 30px 30px 50px;
        border-top: solid 1px #000000;
        border-bottom: solid 1px #000000;
        margin-left: -5.5%;
        border-radius: 30px;
    }
    @keyframes scroll-grid {
        0% {
            background-position: 30px 10px;
        }
        100% {
            background-position: 0px 0px;
        }
    }
    @media screen and (max-width: 1200px){
        .view-content {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(100% - 2px);
            max-width: 1600px;
            margin: auto;
            flex-wrap: wrap;
            margin-top: -5px;
            border:none;
            padding:0;
        }
        .view-container{
            padding: 0;
            padding-bottom: 100px;
            margin-top: 0px;
            width: calc(100% - 0px) !important;
            margin-top: -5px;
            border: none;
            border-radius: 0;
        }
        .Presentation-image{
            display:none;
        }
        
        .Presentation-texte{
            margin-left: 0%;
            border:none;
            border-radius: 0;
        }
        #telechargement{
            padding-top:20px;
            padding-bottom: 20px;
        }
        .Presentation-image{
            display: block !important;
        }
    }
</style>